import { useEffect, useState } from 'react';
import useIsMobile from './useIsMobile';

// Long lists on a phone: render the first `step` items and offer "Show
// more" instead of a 50,000px page (Accounts, Directory). The search box
// stays the fast way in; the limit resets whenever `resetKey` changes (pass
// the search text / filters). Desktop always gets the full list.
export default function usePhoneLimit(items, resetKey, step = 40) {
  const isMobile = useIsMobile();
  const [limit, setLimit] = useState(step);
  useEffect(() => { setLimit(step); }, [resetKey, step]);
  const list = items || [];
  if (!isMobile) return { shown: list, rest: 0, more: () => {} };
  return {
    shown: list.slice(0, limit),
    rest: Math.max(0, list.length - limit),
    more: () => setLimit(l => l + step),
  };
}

export function ShowMore({ rest, onMore, step = 40 }) {
  if (!rest) return null;
  return (
    <button type="button" className="m-btn m-btn-secondary" style={{ margin: '12px 0' }} onClick={onMore}>
      Show {Math.min(step, rest)} more <span style={{ color: 'var(--text-faint)', fontWeight: 500 }}>({rest.toLocaleString('en-US')} left)</span>
    </button>
  );
}
